const PREFIX = 'telemetry.pagination';

export function getStoredPage(storageKey, fallback = 1) {
	if (typeof window === 'undefined') {
		return fallback;
	}

	try {
		const value = sessionStorage.getItem(`${PREFIX}.${storageKey}.page`);
		if (value === null) {
			return fallback;
		}

		const page = Number(value);
		return Number.isFinite(page) && page > 0 ? page : fallback;
	} catch {
		return fallback;
	}
}

export function getStoredPerPage(storageKey, fallback = 10) {
	if (typeof window === 'undefined') {
		return fallback;
	}

	try {
		const value = sessionStorage.getItem(`${PREFIX}.${storageKey}.perPage`);
		if (value === null) {
			return fallback;
		}

		const perPage = Number(value);
		return Number.isFinite(perPage) && perPage > 0 ? perPage : fallback;
	} catch {
		return fallback;
	}
}

export function setStoredPage(storageKey, page) {
	try {
		sessionStorage.setItem(`${PREFIX}.${storageKey}.page`, String(Math.max(1, page)));
	} catch {
		// Ignore quota / private mode errors.
	}
}

export function setStoredPerPage(storageKey, perPage) {
	try {
		sessionStorage.setItem(`${PREFIX}.${storageKey}.perPage`, String(Math.max(1, perPage)));
	} catch {
		// Ignore quota / private mode errors.
	}
}
